import { Box, useTheme } from "@mui/material";
import { avatarColors } from "../../styles/generalStyles";
import { getColorFromName, getInitials } from "../../utils/formatData";
import styles from "./UserAvatar.module.css";

const UserAvatar = ({ name, size = 40 }) => {
    const theme = useTheme();
    return (
        <Box
            className={styles.avatar}
            style={{
                "--size": size + "px",
                "--backgroundColor": getColorFromName(name, avatarColors),
                "--textColor": theme.palette.text.primary,
            }}
        >
            {getInitials(name)}
        </Box>
    );
};

export default UserAvatar;
